import React, { useState, useEffect } from "react";
import styles from "./ui.module.css";

const PhoneInput = ({
  label,
  value = "",
  onChange,
  required = false,
  error = "",
}) => {
  const [displayValue, setDisplayValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (value) {
      const cleaned = value.replace(/\D/g, "");
      let formattedValue = "+7 ";
      
      if (cleaned.length > 1) {
        const rest = cleaned.slice(1);
        const part1 = rest.slice(0, 3);
        const part2 = rest.slice(3, 6);
        const part3 = rest.slice(6, 8);
        const part4 = rest.slice(8, 10);
        
        formattedValue += part1;
        if (part2) formattedValue += ` ${part2}`;
        if (part3) formattedValue += ` ${part3}`;
        if (part4) formattedValue += ` ${part4}`;
      }
      
      setDisplayValue(formattedValue);
    } else {
      setDisplayValue("");
    }
  }, [value]);

  const handleChange = (e) => {
    const input = e.target.value;
    const cleaned = input.replace(/\D/g, "");
    let newValue = cleaned.slice(0, 11);
    
    if (newValue.length > 0 && newValue[0] === "8") {
      newValue = "7" + newValue.slice(1);
    } else if (newValue.length > 0 && newValue[0] !== "7") {
      newValue = "7" + newValue;
    }
    
    onChange(newValue);
  };

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <input
          type="tel"
          value={displayValue}
          onChange={handleChange}
          required={required}
          placeholder={isFocused || displayValue ? "" : label}
          className={`${styles.input} ${error ? styles.inputError : ""}`}
          maxLength={18}
          onFocus={() => setIsFocused(true)}
          onBlur={() => !displayValue && setIsFocused(false)}
        />
        <label
          className={`${styles.label} ${
            isFocused || displayValue ? styles.labelFloating : ""
          }`}
        >
          {label}
        </label>
      </div>
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};

export default PhoneInput;